import { combineReducers } from 'redux'
import * as t from './actionTypes'
import {setterReducer} from '../common/redux'

const trainShown = setterReducer(false, t.SET_TRAIN_MSG_SHOWN)

const tutorials = combineReducers({
  trainShown: trainShown,
})

export {tutorials as default}


// WEBPACK FOOTER //
// ./assets/interview/tutorials.js